var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import { Slider } from '@material-ui/core';
import classnames from 'classnames';
import { omit } from 'ramda';
import { categoryByPolicyThreatLevel } from '../../util/threatLevels';
import { pathSet } from '../../util/jsUtil';
import { propTypes } from './types';
export { propTypes } from './types';
import './NxPolicyThreatSlider.scss';
/**
 * A ValueLabelComponent that renders the values inside of the thumbs and changes CSS classes depending on
 * position/value
 */
function NxPolicyThreatSliderValueLabelDisplay(_a) {
    var value = _a.value, children = _a.children, className = _a.className, otherProps = __rest(_a, ["value", "children", "className"]);
    // this impl doesn't need to support these props. Filter them out so they don't cause react warnings on the span
    var filteredProps = omit(['open', 'valueLabelFormat', 'valueLabelDisplay'], otherProps), thumb = React.Children.only(children), 
    // the thumb element isn't initially constructed with any children. Add the value as its child
    thumbWithLabel = pathSet(['props', 'children'], value, thumb), limitedValue = Math.min(10, Math.max(0, Math.round(value))), threatCategory = categoryByPolicyThreatLevel[limitedValue], nxBaseClass = 'nx-policy-threat-slider__value-label', classes = classnames(nxBaseClass, nxBaseClass + "--" + threatCategory, className);
    return (React.createElement("span", __assign({ className: classes }, filteredProps), thumbWithLabel));
}
var NxPolicyThreatSlider = function NxPolicyThreatSlider(_a) {
    var onChange = _a.onChange, value = _a.value, className = _a.className;
    var classes = classnames('nx-policy-threat-slider', className);
    function sliderOnChange(_, val) {
        if (onChange) {
            onChange(val);
        }
    }
    return (React.createElement("div", { className: classes },
        React.createElement(Slider, { value: value, min: 0, max: 10, marks: true, ValueLabelComponent: NxPolicyThreatSliderValueLabelDisplay, onChange: sliderOnChange })));
};
NxPolicyThreatSlider.propTypes = propTypes;
export default NxPolicyThreatSlider;
//# sourceMappingURL=NxPolicyThreatSlider.js.map